import React from 'react';

interface VenereMessageBubbleProps {
  message: string;
  timestamp: string;
  isUser: boolean;
}

const VenereMessageBubble: React.FC<VenereMessageBubbleProps> = ({
  message,
  timestamp,
  isUser,
}) => {
  const formatMessageTime = (timestamp: string) => {
    try {
      
      let date: Date;
      
      // Handle different timestamp formats
      if (timestamp.includes('T') && timestamp.includes('Z')) {
        // ISO 8601 format with Z (UTC)
        date = new Date(timestamp);
      } else if (timestamp.includes('T') && !timestamp.includes('Z')) {
        // ISO 8601 format without Z (assume local time)
        date = new Date(timestamp + 'Z');
      } else {
        // Try parsing as is
        date = new Date(timestamp);
      }
      
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        console.error('Invalid date:', timestamp);
        return '--:--';
      }
      
      // Format using local timezone
      const localTime = date.toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      
      return localTime;
    } catch (error) {
      console.error('Error formatting message time:', error);
      return '--:--';
    }
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3`}>
      <div className={`relative max-w-xs lg:max-w-md min-w-[120px] ${isUser ? 'ml-12' : 'mr-12'}`}>
        {/* Message Bubble */}
        <div
          className={`px-4 py-2 rounded-2xl ${
            isUser
              ? 'venere-bg-royal text-white'
              : 'bg-white border border-gray-200'
          }`}
          style={{
            borderRadius: isUser 
              ? '18px 18px 4px 18px' 
              : '18px 18px 18px 4px',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto'
          }}
        >
          <div 
            className="text-sm leading-relaxed venere-message-text-wrap"
          >
            {message}
          </div>
          <div
            className={`text-xs mt-1 ${
              isUser ? 'text-venere-matcha' : 'text-gray-500'
            }`}
          >
            {formatMessageTime(timestamp)}
          </div>
        </div>

        {/* Corner/Tail */}
        <div
          className={`absolute bottom-2 w-0 h-0 ${
            isUser
              ? 'right-0 transform translate-x-full'
              : 'left-0 transform -translate-x-full'
          }`}
        >
          <div
            className={`w-0 h-0 border-6 border-transparent ${
              isUser
                ? 'border-l-venere-royal border-r-0 border-t-0 border-b-0'
                : 'border-r-gray-200 border-l-0 border-t-0 border-b-0'
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default VenereMessageBubble;